import React from 'react';
import Section from 'components/Section';
import IconLabel from 'components/common/IconLabel';

export default ({ id, title, description, items }) => (
  <Section name={id} title={title} description={description}>
    <div className="row mt-5 mt-sm-6 mb-6 text-center">
      {items.map((item, i) => {
        const icon = item.icon ? item.icon.name : "";
        return <div className="col-10 offset-1 offset-sm-0 col-sm-6 col-md-4 service-item mb-45" key={i}>
            <IconLabel icon={icon} label={item.title} large={true}/>
          </div>;
      })}
    </div>
  </Section>
);


// WEBPACK FOOTER //
// ./src/components/Services.js